import Image from 'next/image';

import { Typography } from '@mui/material';
import Card from '@mui/material/Card';
import type { Theme } from '@mui/material/styles';
import { styled } from '@mui/system';

export const ArrowForwardStyle = (theme: Theme): React.CSSProperties => ({
  width: theme.typography.fontSize,
  height: theme.typography.fontSize,
  cursor: 'pointer',
});

export const SearchMultipleContainer = styled(Card)(({ theme }) => ({
  background: theme.palette.common.mds_global_color_white,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.08)',
  margin: theme.spacing(1.5),
}));

export const SearchMultipleBox = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const SearchMultipleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const SearchMultipleImage = styled(Image)(({ theme }) => ({
  width: theme.spacing(4),
  height: theme.spacing(4),
}));
